/**
 * Validate the data in the notifications model.
 */
class NotificationsValidation {
  constructor() {
    this.errorMessages = {
      // notify_battery
      BATTERY_PERCENTAGE_INVALID: __('The battery percentage should be between 1 and 100.'),

      // notify_temperature
      // TEMP_MIN_GREATER_THAN_MAX: 'The maximum temperature cannot be less than the minimum.',
      TEMP_NAN: __('Temperatures must be a number.'),

      // notify_speed
      SPEED_NAN: __('Speed must be a number.'),

      // notify_geofence
      GEOFENCE: __('Use the map to define the geofence area.'),

      // notify_by_email
      EMAIL_INVALID: __('One or more emails are invalid.'),

      // notify_by_sms
      PHONE_INVALID: __('One or more phone numbers are invalid.'),
    }
    this.errors = {}
    this.valid = true
  }

  /**
   * Whether the form is valid enough to have the save button enabled.
   */
  canSave(model) {
    this.errors = {}
    this.valid = true
    this.validateTemperature(model)
    this.validateBattery(model)
    this.validateSpeed(model)
    if (model.hasNotifications() && ! model.hasRecipients()) {
      this.valid = false
    }

    return this.valid
  }

  /**
   * Validate the values in any notifications that are enabled.
   */
  validateForm(model) {
    this.errors = {}
    this.valid = true
    this.validateTemperature(model)
    this.validateBattery(model)
    this.validateSpeed(model)
    this.validateGeofence(model)
    this.validateEmails(model)
    this.validatePhones(model)
  }

  /**
   * Validate the temperature range in the notify_temperature field.
   */
  validateTemperature(model) {
    const enabled = model.configs['temp'].enabled
    const min = model.configs['temp'].values[0]
    const max = model.configs['temp'].values[1]
    if (min !== '' && max !== '') {
      // min and max are both numbers
      if (min > max) {
        // Swap min and max instead of showing an error. A range is a range.
        // this.errors['notify_temperature'] = this.errorMessages['TEMP_MIN_GREATER_THAN_MAX']
        // this.valid = false
        model.configs['temp'].setValues(max, min)
      }
    }
    else if (enabled && (min === '' || max === '')) {
      // The user needs to specify the temperature range.
      this.errors['notify_temperature'] = this.errorMessages['TEMP_NAN']
      this.valid = false
    }
  }

  /**
   * Validate the battery percent in the notify_battery_percent field.
   */
  validateBattery(model) {
    const enabled = model.configs['batt'].enabled
    const battery = model.configs['batt'].values[0]
    if (battery !== '') {
      if (battery < 1) {
        // 1 is the min so correct the value for the user.
        model.configs['batt'].values[0] = 1
      }
      else if (battery > 100) {
        // 100 is max so correct the value for the user.
        model.configs['batt'].values[0] = 100
      }
    }
    else if (enabled && battery === '') {
      // The user needs to specify the battery percentage threshold.
      this.errors['notify_battery'] = this.errorMessages['BATTERY_PERCENTAGE_INVALID']
      this.valid = false
    }
  }

  /**
   * Validate the speed limit in the notify_speed_limit field.
   */
  validateSpeed(model) {
    const enabled = model.configs['speed'].enabled
    const speed = model.configs['speed'].values[0]
    if (speed !== '') {
      if (speed < 0) {
        // Speed is a magnitude so correct the value for the user.
        model.configs['speed'].values[0] = Math.abs(speed)
      }
    }
    else if (enabled && speed === '') {
      // The user needs to specify the speed limit.
      this.errors['notify_speed'] = this.errorMessages['SPEED_NAN']
      this.valid = false
    }
  }

  /**
   * Validate the geofence polygon exists if geofence is checked.
   */
  validateGeofence(model) {
    const enabled = model.configs['geofence'].enabled
    const polygon = model.configs['geofence'].values[0]
    if (enabled && polygon === '') {
      // The user needs to specify the geofence polygon.
      this.errors['notify_geofence'] = this.errorMessages['GEOFENCE']
      this.valid = false
    }
  }

  /**
   * Validate emails in the notify_emails field.
   */
  validateEmails(model) {
    const enabled = model.configs['emails'].enabled
    const emails = model.configs['emails'].values
    // console.log('emails', emails)
    for (let i = 0; i < emails.length; i++) {
      if ( ! validateEmail(emails[i])) {
        this.errors['notify_by_email'] = this.errorMessages['EMAIL_INVALID'];
        this.valid = false
        break
      }
    }
  }

  /**
   * Validate phone numbers in the notify_phones field.
   */
  validatePhones(model) {
    const enabled = model.configs['numbers'].enabled
    const phones = model.configs['numbers'].values
    // console.log('phones', phones)
    for (let i = 0; i < phones.length; i++) {
      if (phones[i].replace(/\D/g, '').length !== 10) {
        // Any string with 10 digits in it is accepted.
        // 1234567890, (555)555-1234, 555-555-5555, 123.555.1234, a1b2c34567890def
        // @TODO is any more validation necessary on the front-end?
        this.errors['notify_by_sms'] = this.errorMessages['PHONE_INVALID'];
        this.valid = false
        break
      }
    }
  }
}

export { NotificationsValidation }
